import { render, staticRenderFns } from "./HistoricCandidates.vue?vue&type=template&id=5c3f0af5&scoped=true"
import script from "./HistoricCandidates.vue?vue&type=script&lang=js"
export * from "./HistoricCandidates.vue?vue&type=script&lang=js"
import style0 from "./HistoricCandidates.vue?vue&type=style&index=0&id=5c3f0af5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f0af5",
  null
  
)

export default component.exports